import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { MpTag } from 'shared/ui/MpTag';

interface SubscriptionStatusProps {
	status: number;
}

export const SubscriptionStatus: FC<SubscriptionStatusProps> = ({ status }) => {
	const { t } = useTranslation();
	switch (status) {
		case 2:
			return <MpTag color='error'>{t(`Marketplace_Subscription_Not_Active`)}</MpTag>;
		case 1:
			return <MpTag color='error'>{t(`Marketplace_Subscription_Cancelled`)}</MpTag>;
		default:
			return <MpTag>{t(`Marketplace_Subscription_Active`)}</MpTag>;
	}
};
